exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.search-bar-bg[data-v-ce60fe2a] {\n  background: white;\n}\n", ""]);

// exports
